/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Lock16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M8 1a4 4 0 013.995 3.8L12 5v1a2 2 0 012 2v5a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2V5c0-2.21 1.79-4 4-4zm1.5 9h-3a.5.5 0 00-.09.992L6.5 11h3a.5.5 0 000-1zM8 3a2.001 2.001 0 00-1.995 1.85L6 5v1h4V5a2 2 0 00-2-2z"
        />
    </AccessibleSVG>
);

export default Lock16;
